// Libraries
import { createSlice, PayloadAction, Draft } from '@reduxjs/toolkit';
import { mergeRight } from 'ramda';

// MUI
// Core
import auth from '../core/authorization';

// Common
// Interfaces
import { IPersonDetailsExtended } from '../interfaces/IBusinessEntities';

// Store
// API
import api from '../api/startupApi';

// Store
import { SliceStatus } from './IStore';

// Feature - Person
import { fetchPersonRelations } from '../persons/fetchPersonRelations';

interface UserDataState {
    data: IPersonDetailsExtended;
    status: SliceStatus;
}

const initialState: UserDataState = {
    data: {
        Addresses: [],
        Aliases: [],
        EffectiveTo: null,
        EmailAddresses: [],
        FirstName: '',
        Id: null,
        LanguageShortCode: 'FI',
        LastName: '',
        Logins: [],
        PhoneNumbers: [],
        IsSnellmanUser: null,
        CompanyRelations: [],
        IsTrafficContractor: null,
        IsDriver: null,
        DoubleAuthenticationEnabled: false,
        IsBarnUser: null,
    },
    status: 'initial',
};

function loadData(state: Draft<UserDataState>, action: PayloadAction<IPersonDetailsExtended>) {
    state.data = mergeRight(state.data, action.payload);
    state.status = 'ready';
}

const userDataSlice = createSlice({
    name: 'userData',
    initialState,
    reducers: {
        load: loadData,
        updateIsLoading(state) {
            state.status = 'loading';
        },
    },
});

const { load, updateIsLoading } = userDataSlice.actions;

export const loadUserDataAsync = () => {
    return async (dispatch: any) => {
        try {
            dispatch(updateIsLoading());
            const userData = await api.getUserInfo();
            if (userData && userData?.Entity.Logins[0].Login) {
                const loginName = userData?.Entity.Logins[0].Login;
                await fetchPersonRelations(loginName).then((response) => {
                    userData.Entity.IsSnellmanUser = response[0];
                    userData.Entity.CompanyRelations = response[1];
                });

                userData.Entity.IsTrafficContractor = auth.hasTransportOperatorAccess;
                userData.Entity.IsDriver = auth.hasDriverAccess;
                userData.Entity.IsBarnUser = auth.hasBarnAccess;
            }

            dispatch(load(userData?.Entity || initialState.data));
        } catch (err) {
            console.error(err);
        }
    };
};

export default userDataSlice.reducer;
